import { API_BASE_URL } from "../../app/config"

/** isImage determines if a given observation file refers to an <image> */
export const isImage = ({ type }) => type && type.includes("image/")

/** isVideo determines if a given observation file refers to a <video> */
export const isVideo = ({ type }) => type && type.includes("video/")

/** isHtml determines if a given observation file refers to a <html> document */
export const isHtml = ({ type }) => type && type.includes("text/html")

/** mediaSrc produces the URI to use as the `src` attribute to render a given
 * file of a given recording. */
export const mediaSrc = (observationId, fileId, authToken) =>
  observationId && fileId
    ? `${API_BASE_URL}/api/observations/${observationId}/${fileId}${
        authToken ? "?token=" + encodeURIComponent(authToken) : ""
      }`
    : undefined

/** preFetchImg is a simple fire-and-forget operation to hint at the browser
 * to pre-fetch and cache the given image (src). Note: Not intended for video!
 */
export const preFetchImg = (src) => {
  if (!src) {
    return
  }
  const img = new Image()
  //img.onload = () => console.log("preFetchImg done:", src)
  img.src = src
}

/** preFetchFile is a simple fire-and-forget operation to
 * hint at the browser to pre-fetch and cache the data for the given
 * file within the given observation. */
export const preFetchFile = (observationId, file = {}, authToken) => {
  if (isImage(file)) {
    preFetchImg(mediaSrc(observationId, file.id, authToken))
  }
}

// TODO: Perhaps to make better use of limited back-end bandwidth,
// make a function `preFetchAll(files) -> Promise<>` which allows
// us to thoughtfully chain together pre-fetch for entire observations,
// and cancel pre-fetching when, for example, navigating further away from
// the 'previous' one.
